import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  connect() {
    this.initTooltips()

    this.observer = new MutationObserver((mutations) => {
      this.initTooltips()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  initTooltips() {
    const selector = '[data-bs-toggle="tooltip"]'
    const elements = document.querySelectorAll(selector)
    elements.forEach(el => {
      if (!Tooltip.getInstance(el)) {
        new Tooltip(el)
      }
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()

    this.element.querySelectorAll('[data-bs-toggle="tooltip"], .has-tooltip').forEach(el => {
      const tooltip = Tooltip.getInstance(el)
      if (tooltip) tooltip.dispose()
    })
  }
}
